import { initMainSlider } from './main-slider';
import { initBrandsSlider } from './brands-slider';
import { initCategoriesSlider } from './categories-slider';

initMainSlider();
initCategoriesSlider();
initBrandsSlider();
